import httpServices from 'services/http.service';
import { API_URLS } from 'config/constants';

export const uploadFile = (data: FormData) => (
  httpServices.post(API_URLS.STORAGE.UPLOAD, data)
);
